export default __webpack_public_path__ + "static/media/SZ.ac68d161.svg";